import { useTranslation } from 'react-i18next';

/**
 * Гайд.
 *
 * Отвечает на три вопроса, которые иначе задают в поддержку: где лежит гифт,
 * что будет при просрочке и почему цена выше флора. Всё — до того, как
 * человек заплатит, а не после.
 */
export function Guide() {
  const { t } = useTranslation();

  const faq = [
    ['guide.seller_puts_gift_into', 'guide.moment_they_can_t'],
    ['guide.pay_parts', 'guide.gift_stays_contract_whole'],
    ['guide.last_payment_gift_yours', 'guide.contract_does_transfer_automatically'],
    ['guide.what_if_seller_changes', 'guide.after_down_payment_they'],
    ['guide.can_i_late_payment', 'guide.yes_grace_period_144'],
    ['guide.why_price_above_floor', 'guide.premium_price_paying_over'],
  ] as const;

  return (
    <div className="screen">
      <div className="col" style={{ gap: 2 }}>
        <strong style={{ fontSize: 17 }}>{t('guide.how_works')}</strong>
        <span className="muted" style={{ fontSize: 13 }}>{t('guide.gift_sits_contract_while')}</span>
      </div>

      <div className="card col" style={{ background: 'var(--lime-soft)', borderColor: 'transparent' }}>
        <strong style={{ fontSize: 14 }}>{t('offer.where_gift_sits_until')}</strong>
        <span className="muted" style={{ fontSize: 13 }}>{t('guide.can_t_show_telegram')}</span>
      </div>

      <div className="label">{t('guide.faq')}</div>
      {faq.map(([q, a]) => (
        <div key={q} className="card col" style={{ gap: 4 }}>
          <strong style={{ fontSize: 14 }}>{t(q)}</strong>
          <span className="muted" style={{ fontSize: 13 }}>{t(a)}</span>
        </div>
      ))}
    </div>
  );
}
